import React from 'react';

export default function Stripe() {
  return (
    <svg width="62" height="40" viewBox="0 0 62 40">
      <path d="M62,20.42c0-4.43-2.13-7.93-6.2-7.93S49.22,16,49.22,20.41c0,5.2,2.93,7.86,7.08,7.86a9.66,9.66,0,0,0,4.81-1.12V23.68a9,9,0,0,1-4.22,1c-1.68,0-3.15-.6-3.35-2.6H62C62,21.73,62,20.87,62,20.42Zm-8.51-1.63c0-1.95,1.19-2.77,2.27-2.77s2.17.82,2.17,2.77Z" />
      <path d="M42.51,12.49a4.72,4.72,0,0,0-3.36,1.36L39,12.77h-3.8V33l4.31-.92v-4.9a4.77,4.77,0,0,0,3,1.09c3.09,0,5.89-2.49,5.89-8C48.41,15.22,45.57,12.49,42.51,12.49Zm-1,12a2.61,2.61,0,0,1-2-.83V17.18a2.56,2.56,0,0,1,2-.86c1.58,0,2.66,1.77,2.66,4s-1.05,4.09-2.65,4.09Z" />
      <path d="M29.25,11.45l4.31-.92V7l-4.31.93Z" />
      <path d="M29.25,12.77h4.31V28H29.25Z" />
      <path d="M24.61,14.05l-.26-1.28H20.63V28h4.3V17.67a3,3,0,0,1,3.28-.91v-4A2.93,2.93,0,0,0,24.61,14.05Z" />
      <path d="M16,9l-4.2.87V23.74a4.29,4.29,0,0,0,1.25,3.15,4.47,4.47,0,0,0,3.18,1.31,6.67,6.67,0,0,0,3-.57V24.17c-.55.22-3.27,1-3.27-1.54V16.47h3.27v-3.7H16Z" />
      <path d="M4.35,17.18c0-.67.56-.93,1.46-.93a9.53,9.53,0,0,1,4.28,1.15V13.27a11.35,11.35,0,0,0-4.28-.78C2.33,12.49,0,14.32,0,17.4c0,4.79,6.54,4,6.54,6.07,0,.79-.69,1.05-1.65,1.05a10.58,10.58,0,0,1-4.7-1.37v4.14a11.77,11.77,0,0,0,4.69,1c3.54,0,6-1.78,6-4.9C10.92,18.21,4.35,19.13,4.35,17.18Z" />
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/components/icons/Stripe/index.js